module.exports = __webpack_public_path__ + "static/media/team2018.76b4453e.jpeg";